import { Button, StyleProps } from "@chakra-ui/react";
import { ContentExpandButton } from "shared/components/button/ContentExpandButton";

export interface TableBoxHeaderExpandButtonProps extends StyleProps {
  isExpanded: boolean;
  onClick: () => void;
}

export const TableBoxHeaderExpandButton: React.FC<
  React.PropsWithChildren<TableBoxHeaderExpandButtonProps>
> = ({ isExpanded, onClick, children, ...props }) => (
  <Button
    variant="unstyled"
    onClick={(e) => {
      e.stopPropagation();
      onClick();
    }}
    data-ls-enabled={true}
    data-public={true}
    display="flex"
    gap="4px"
    paddingRight={0}
    paddingInlineStart={0}
    borderRadius={0}
    paddingLeft="16px"
    minWidth="40px" // 24px desired min width + 16px left padding
    minHeight="24px"
    alignSelf="stretch"
    ml="-24px"
    mr="-8px"
    {...props}
  >
    <ContentExpandButton isExpanded={isExpanded} />
    {children}
  </Button>
);
